import { Program } from 'types/program';
import { Season } from 'types/seasons';
import dayjs from 'dayjs';
import { getDateStringWithYear } from 'lib/dates';

const labels = {
	y: 'year',
	m: 'month',
	from: 'From',
	andUp: 'and up',
	ageCutoff: 'Age cutoff date',
	old: 'old',
	on: 'on',
};

const getAgeRangeTag = (minAge: string, maxAge: string) => {
	const [min, minUnit] = minAge.split(' ');
	const [max, maxUnit] = maxAge.split(' ');

	if (min === max && minUnit === maxUnit) {
		return `${max} ${maxUnit === 'y' ? labels.y : labels.m}${Number(max) > 1 ? 's' : ''}`;
	}

	const minDesc = `${min} ${
		Number(max) === 10000 || minUnit !== maxUnit ? (minUnit === 'y' ? labels.y : labels.m) : ''
	}${Number(min) > 1 && minUnit !== maxUnit ? 's' : ''}`;
	const maxDesc = `${max} ${maxUnit === 'y' ? labels.y : labels.m}${Number(max) > 1 ? 's' : ''} ${labels.old}`;

	return `${Number(max) === 10000 ? `${labels.from} ${minDesc} ${labels.andUp}` : `${minDesc} - ${maxDesc}`}`;
};

export function getTags(data: Program | Season) {
	let ageRangeTag = '';
	let ageCutoffTag = '';

	if (data.minAge && data.maxAge) {
		ageRangeTag = getAgeRangeTag(data.minAge, data.maxAge);
	}

	if (data.ageCalcDate && !dayjs(data.ageCalcDate).isSame(dayjs(data.startDate))) {
		ageCutoffTag = getDateStringWithYear(dayjs(data.ageCalcDate).toDate());
		ageRangeTag = `${ageRangeTag} ${labels.on} ${ageCutoffTag}`;
	}

	return [ageRangeTag];
}
